/* TTeSIM voice search — EN / Cantonese / Mandarin
 * Mic -> speech-to-text -> parse(countries, days, data) -> match products
 * -> variant pickers -> Buy Now -> /checkout. Existing eSIM provisioning untouched. */
(function () {
  'use strict';

  /* ---------- Chinese country -> product title ---------- */
  var ZH_COUNTRY = {
    '日本': 'Japan', '韩国': 'South Korea', '韓國': 'South Korea',
    '中国': 'China', '中國': 'China', '台湾': 'China.Taiwan', '台灣': 'China.Taiwan',
    '香港': 'China.HongKong', '澳门': 'China.Macau', '澳門': 'China.Macau',
    '泰国': 'Thailand', '泰國': 'Thailand', '越南': 'Vietnam',
    '新加坡': 'Singapore', '马来西亚': 'Malaysia', '馬來西亞': 'Malaysia',
    '印尼': 'Indonesia', '印度尼西亚': 'Indonesia', '印度尼西亞': 'Indonesia',
    '菲律宾': 'Philippines', '菲律賓': 'Philippines',
    '柬埔寨': 'Cambodia', '老挝': 'Laos', '老撾': 'Laos',
    '印度': 'India', '尼泊尔': 'Nepal', '尼泊爾': 'Nepal',
    '斯里兰卡': 'Sri Lanka', '斯里蘭卡': 'Sri Lanka',
    '马尔代夫': 'Maldives', '馬爾代夫': 'Maldives',
    '孟加拉': 'Bangladesh', '巴基斯坦': 'Pakistan', '蒙古': 'Mongolia',
    '阿富汗': 'Afghanistan', '哈萨克斯坦': 'Kazakhstan', '哈薩克斯坦': 'Kazakhstan',
    '美国': 'United States', '美國': 'United States',
    '加拿大': 'Canada', '墨西哥': 'Mexico',
    '英国': 'United Kingdom', '英國': 'United Kingdom',
    '法国': 'France', '法國': 'France', '德国': 'Germany', '德國': 'Germany',
    '意大利': 'Italy', '義大利': 'Italy', '西班牙': 'Spain', '葡萄牙': 'Portugal',
    '荷兰': 'Netherlands', '荷蘭': 'Netherlands', '比利时': 'Belgium', '比利時': 'Belgium',
    '瑞士': 'Switzerland', '奥地利': 'Austria', '奧地利': 'Austria',
    '希腊': 'Greece', '希臘': 'Greece', '土耳其': 'Turkey',
    '俄罗斯': 'Russia', '俄羅斯': 'Russia', '乌克兰': 'Ukraine', '烏克蘭': 'Ukraine',
    '波兰': 'Poland', '波蘭': 'Poland', '捷克': 'Czech Republic',
    '匈牙利': 'Hungary', '瑞典': 'Sweden', '挪威': 'Norway',
    '丹麦': 'Denmark', '丹麥': 'Denmark', '芬兰': 'Finland', '芬蘭': 'Finland',
    '冰岛': 'Iceland', '冰島': 'Iceland', '爱尔兰': 'Ireland', '愛爾蘭': 'Ireland',
    '澳洲': 'Australia', '澳大利亚': 'Australia', '澳大利亞': 'Australia',
    '新西兰': 'New Zealand', '新西蘭': 'New Zealand', '紐西蘭': 'New Zealand',
    '斐济': 'Fiji', '斐濟': 'Fiji', '萨摩亚': 'Samoa', '薩摩亞': 'Samoa',
    '汤加': 'Tonga', '湯加': 'Tonga', '巴布亚新几内亚': 'Papua New Guinea', '巴布亞新畿內亞': 'Papua New Guinea',
    '阿联酋': 'United Arab Emirates', '阿聯酋': 'United Arab Emirates', '迪拜': 'United Arab Emirates',
    '沙特': 'Saudi Arabia', '沙地': 'Saudi Arabia',
    '卡塔尔': 'Qatar', '卡塔爾': 'Qatar', '科威特': 'Kuwait',
    '巴林': 'Bahrain', '阿曼': 'Oman', '以色列': 'Israel',
    '约旦': 'Jordan', '約旦': 'Jordan', '伊拉克': 'Iraq',
    '埃及': 'Egypt', '摩洛哥': 'Morocco', '突尼斯': 'Tunisia',
    '阿尔及利亚': 'Algeria', '阿爾及利亞': 'Algeria',
    '南非': 'South Africa', '肯尼亚': 'Kenya', '肯尼亞': 'Kenya',
    '尼日利亚': 'Nigeria', '尼日利亞': 'Nigeria', '加纳': 'Ghana', '加納': 'Ghana',
    '埃塞俄比亚': 'Ethiopia', '埃塞俄比亞': 'Ethiopia',
    '坦桑尼亚': 'Tanzania', '坦桑尼亞': 'Tanzania',
    '巴西': 'Brazil', '阿根廷': 'Argentina', '智利': 'Chile',
    '秘鲁': 'Peru', '祕魯': 'Peru', '哥伦比亚': 'Colombia', '哥倫比亞': 'Colombia',
    '欧洲': 'Europe', '歐洲': 'Europe', '亚洲': 'Asia', '亞洲': 'Asia',
    '中东': 'Middle East', '中東': 'Middle East',
    '非洲': 'Africa', '拉丁美洲': 'Latin America', '拉美': 'Latin America',
    '南美': 'South America', '北美': 'North America',
    '大洋洲': 'Oceania', '全球': 'Global'
  };

  /* English aliases -> product title (word-boundary matched) */
  var EN_ALIAS = {
    'usa': 'United States', 'uk': 'United Kingdom', 'uae': 'United Arab Emirates',
    'nz': 'New Zealand', 'korea': 'South Korea', 'england': 'United Kingdom',
    'america': 'United States', 'holland': 'Netherlands'
  };

  var REC_LANG = 'en-US';

  /* ---------- Chinese numerals -> number ---------- */
  var CN_D = { '一': 1, '二': 2, '三': 3, '四': 4, '五': 5, '六': 6, '七': 7, '八': 8, '九': 9, '兩': 2, '两': 2, '零': 0 };
  function cn2num(s) {
    s = String(s).trim();
    if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s);
    var total = 0, cur = 0;
    for (var i = 0; i < s.length; i++) {
      var ch = s[i];
      if (ch === '百') { total += (cur || 1) * 100; cur = 0; }
      else if (ch === '十') { total += (cur || 1) * 10; cur = 0; }
      else if (CN_D[ch] !== undefined) { cur = CN_D[ch]; }
    }
    return total + cur;
  }

  /* ---------- query parser ---------- */
  function parseQuery(text) {
    var q = { countries: [], days: null, dataMB: null, raw: text };
    var t = text || '';

    // days: EN "5 days" / ZH "五天" / "兩個星期"
    var m = t.match(/(\d+)\s*days?/i);
    if (m) { q.days = parseInt(m[1], 10); }
    if (q.days == null) {
      m = t.match(/([0-9一二三四五六七八九十百兩两]+)\s*天/);
      if (m) { var d = cn2num(m[1]); if (d > 0) q.days = d; }
    }
    if (q.days == null) {
      m = t.match(/([0-9一二三四五六七八九十百兩两]+)\s*個?星期/);
      if (m) { var w = cn2num(m[1]); if (w > 0) q.days = w * 7; }
    }

    // data: "10GB", "500MB", "十GB", "10g"
    m = t.match(/([0-9一二三四五六七八九十百兩两]+(?:\.[0-9]+)?)\s*(gb|mb)/i) ||
        t.match(/([0-9一二三四五六七八九十百兩两]+)\s*g(?![a-z])/i);
    if (m) {
      var amt = cn2num(m[1]);
      var unit = (m[2] || 'g').toLowerCase();
      if (amt > 0) q.dataMB = (unit === 'gb' || unit === 'g') ? Math.round(amt * 1024) : Math.round(amt);
    }

    // "unlimited" keyword (EN/ZH) — no amount number needed
    if (q.dataMB == null && /unlimited|無限|任用/i.test(t)) { q.dataMB = Infinity; }

    // countries: chinese names first
    var found = [];
    for (var zh in ZH_COUNTRY) {
      if (Object.prototype.hasOwnProperty.call(ZH_COUNTRY, zh) && t.indexOf(zh) !== -1) {
        var en = ZH_COUNTRY[zh];
        if (found.indexOf(en) === -1) found.push(en);
      }
    }
    // english aliases (word boundary)
    var low = t.toLowerCase();
    for (var al in EN_ALIAS) {
      if (Object.prototype.hasOwnProperty.call(EN_ALIAS, al)) {
        var re = new RegExp('\\b' + al + '\\b', 'i');
        if (re.test(t)) {
          var ae = EN_ALIAS[al];
          if (found.indexOf(ae) === -1) found.push(ae);
        }
      }
    }
    // english product titles, longest first
    var idx = window.VS_INDEX || [];
    var sorted = idx.slice().sort(function (a, b) { return b.t.length - a.t.length; });
    for (var i = 0; i < sorted.length; i++) {
      var title = sorted[i].t;
      if (title.length < 3) continue;
      if (low.indexOf(title.toLowerCase()) !== -1 && found.indexOf(title) === -1) {
        found.push(title);
      }
    }
    q.countries = found;
    return q;
  }

  /* ---------- product matcher (with regional + global coverage) ---------- */
  /* Regional plans that cover a whole region — shown alongside the exact country plan.
     Keys are lowercase region names; values are lowercase product titles from VS_INDEX. */
  var REGION_PLANS = {
    'asia': ['asia 4', 'asia 6', 'asia 8', 'asia 16', 'asia 20', 'asia 30',
             'west asia8', 'central asia3',
             'japan & korea', 'china/hk/macau', 'china/hk/macau(cmlink)', 'macao & hk'],
    'europe': ['europe', 'europe 10', 'europe 20', 'europe 33', 'europe 33(promo)',
               'europe 35+5', 'europe 40 & middle east', 'europe 40 & usa',
               'balkans', 'france,germany,italy & uk'],
    'middle east': ['middle east', 'gcc6', 'bahrain,kuwait,qatar & saudi arabia', '西亚3国'],
    'africa': ['africa'],
    'latin america': ['latin america'],
    'north america': ['north america', 'usa&canada', 'usa & mexico'],
    'south america': ['south america'],
    'oceania': ['australia & nz', 'australia & nz(promo)']
  };
  /* Global plans work in every country — always offered as an alternative. */
  var GLOBAL_PLANS = ['global', 'global 100'];
  /* Middle-East countries are tagged "Asia" in the index; map them to the ME region. */
  var ME_OVERRIDE = ['united arab emirates', 'saudi arabia', 'qatar', 'kuwait',
                     'bahrain', 'oman', 'israel', 'jordan', 'iraq'];

  var COUNTRY_ALIASES = {
    'united states': ['usa'],
    'united kingdom': ['uk', 'england'],
    'united arab emirates': ['uae'],
    'south korea': ['korea'],
    'new zealand': ['nz']
  };

  function regionOf(countryTitle) {
    var cl = String(countryTitle || '').toLowerCase();
    if (REGION_PLANS[cl]) return cl;          // user searched a region name directly
    if (cl === 'global') return 'global';
    if (ME_OVERRIDE.indexOf(cl) !== -1) return 'middle east';
    var idx = window.VS_INDEX || [];
    for (var i = 0; i < idx.length; i++) {
      if (idx[i].t.toLowerCase() === cl) {
        var y = (idx[i].y || '').toLowerCase();
        return y === 'common' ? '' : y;
      }
    }
    return '';
  }

  function matchProducts(countries) {
    var idx = window.VS_INDEX || [];
    var byTitle = {};
    for (var i = 0; i < idx.length; i++) byTitle[idx[i].t.toLowerCase()] = idx[i];
    var seen = {}, out = [];
    function add(title, score) {
      var p = byTitle[String(title).toLowerCase()];
      if (p && !seen[p.h]) { seen[p.h] = 1; out.push({ p: p, score: score }); }
    }
    (countries || []).forEach(function (c) {
      var cl = String(c).toLowerCase();
      add(cl, 100);                                              // exact country plan
      var needles = [cl].concat(COUNTRY_ALIASES[cl] || []);      // bundles naming it
      for (var i = 0; i < idx.length; i++) {
        var tl = idx[i].t.toLowerCase();
        if (tl === cl) continue;
        for (var n = 0; n < needles.length; n++) {
          if (tl.indexOf(needles[n]) !== -1) { add(idx[i].t, 60); break; }
        }
      }
      var region = regionOf(c);                                  // regional plans
      (REGION_PLANS[region] || []).forEach(function (t) { add(t, 40); });
      if (region === 'global') GLOBAL_PLANS.forEach(function (t) { add(t, 100); });
      else GLOBAL_PLANS.forEach(function (t) { add(t, 20); });    // global covers everywhere
    });
    out.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.p.t < b.p.t ? -1 : 1;
    });
    return out.slice(0, 14).map(function (s) { return s.p; });
  }

  /* ---------- coverage parser: country list from product description ---------- */
  /* Descriptions carry a "Network: Country Operator Type ..." section. We scan it
     against the known product titles (longest first) to list covered countries. */
  var COV_ALIAS = [
    [/\bKorea\b/g, 'South Korea'],
    [/\bUSA\b/g, 'United States'],
    [/\bUK\b/g, 'United Kingdom']
  ];
  function parseCoverage(desc) {
    var text = String(desc || '').replace(/<[^>]+>/g, ' ');
    var ni = text.search(/network\s*:/i);
    var scope = ni >= 0 ? text.slice(ni) : text;
    for (var a = 0; a < COV_ALIAS.length; a++) scope = scope.replace(COV_ALIAS[a][0], COV_ALIAS[a][1]);
    var idx = window.VS_INDEX || [];
    var titles = idx.map(function (p) { return p.t; })
                    .sort(function (x, y) { return y.length - x.length; });
    var used = {}, found = [];
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      if (t.length < 2) continue;
      var esc = t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re = new RegExp('(^|[^A-Za-z.])' + esc + '(?![A-Za-z.])', 'i');
      if (re.test(scope) && !used[t.toLowerCase()]) {
        used[t.toLowerCase()] = 1;
        found.push(t);
      }
    }
    found.sort(function (x, y) { return x < y ? -1 : 1; });
    return found;
  }

  /* ---------- variant helpers ---------- */
  function dataToMB(s) {
    s = String(s || '');
    var m = s.match(/(\d+(?:\.\d+)?)\s*(gb|mb)/i);
    if (m) {
      var v = parseFloat(m[1]);
      return /gb/i.test(m[2]) ? Math.round(v * 1024) : Math.round(v);
    }
    if (/unlimited/i.test(s)) return Infinity;
    return null;
  }
  function dayNum(s) { var n = parseInt(s, 10); return isNaN(n) ? null : n; }

  function findVariant(variants, dataLabel, dayLabel) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].o1 === dataLabel && variants[i].o2 === dayLabel) return variants[i];
    }
    return null;
  }
  function bestVariant(variants, days, dataMB) {
    var cands = variants.slice();
    if (days != null) {
      var de = cands.filter(function (v) { return v.day === days; });
      if (de.length) cands = de;
    }
    if (dataMB != null) {
      var xe = cands.filter(function (v) { return v.mb === dataMB; });
      if (xe.length) return xe[0];
      var fin = cands.filter(function (v) { return v.mb != null && isFinite(v.mb); });
      if (fin.length) {
        fin.sort(function (a, b) { return Math.abs(a.mb - dataMB) - Math.abs(b.mb - dataMB); });
        return fin[0];
      }
    }
    // prefer finite data options, smallest first
    var fin2 = cands.filter(function (v) { return v.mb != null && isFinite(v.mb); });
    if (fin2.length) { fin2.sort(function (a, b) { return a.mb - b.mb; }); return fin2[0]; }
    return cands[0] || null;
  }

  /* ---------- UI ---------- */
  var els = {};

  function $(sel, root) { return (root || document).querySelector(sel); }

  function status(msg) { if (els.status) els.status.textContent = msg || ''; }

  function money(cents) { return 'USD $' + (cents / 100).toFixed(2); }

  function doSearch(text) {
    text = (text || '').trim();
    if (!text) { status('Please say or type your destination.'); return; }
    var q = parseQuery(text);
    if (!q.countries.length) {
      status('Could not catch a destination — try e.g. "Japan 5 days 10GB" or 「日本五天10GB」.');
      els.results.innerHTML = '';
      return;
    }
    var bits = ['Found: ' + q.countries.join(', ')];
    if (q.days) bits.push(q.days + ' days');
    if (q.dataMB) bits.push(!isFinite(q.dataMB) ? 'Unlimited data' : (q.dataMB >= 1024 ? (q.dataMB / 1024) + 'GB' : q.dataMB + 'MB'));
    status(bits.join(' · '));
    var products = matchProducts(q.countries);
    renderResults(products, q);
  }

  function renderResults(products, q) {
    els.results.innerHTML = '';
    if (!products.length) {
      els.results.innerHTML = '<p class="vs-empty">No matching plans found.</p>';
      return;
    }
    products.forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'vs-card';
      card.innerHTML =
        '<div class="vs-card-title">' + escapeHtml(p.t) + '</div>' +
        '<div class="vs-card-loading">Loading plans…</div>';
      els.results.appendChild(card);
      fetch('/products/' + p.h + '.js')
        .then(function (r) { return r.json(); })
        .then(function (pj) { fillCard(card, p, pj, q); })
        .catch(function () {
          card.querySelector('.vs-card-loading').textContent = 'Could not load plans.';
        });
    });
    els.results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function fillCard(card, p, pj, q) {
    var variants = (pj.variants || []).map(function (v) {
      return { id: v.id, o1: v.option1, o2: v.option2, price: v.price,
               mb: dataToMB(v.option1), day: dayNum(v.option2) };
    }).filter(function (v) { return v.id; });
    if (!variants.length) {
      card.querySelector('.vs-card-loading').textContent = 'No plans available.';
      return;
    }
    // unique data labels (keep original labels), unique days sorted
    var dataSeen = {}, dataLabels = [];
    variants.forEach(function (v) { if (!dataSeen[v.o1]) { dataSeen[v.o1] = 1; dataLabels.push(v.o1); } });
    dataLabels.sort(function (a, b) {
      var ma = dataToMB(a), mb2 = dataToMB(b);
      if (ma == null) return 1; if (mb2 == null) return -1;
      return ma - mb2;
    });
    var daySeen = {}, dayLabels = [];
    variants.forEach(function (v) { if (v.o2 && !daySeen[v.o2]) { daySeen[v.o2] = 1; dayLabels.push(v.o2); } });
    dayLabels.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });

    var best = bestVariant(variants, q.days, q.dataMB) || variants[0];
    var coverage = parseCoverage(pj.description);

    var html =
      '<div class="vs-card-head">' +
      '<div class="vs-card-title">' + escapeHtml(p.t) + '</div>' +
      '<button type="button" class="vs-cov-btn" aria-expanded="false">Countries (' + coverage.length + ') &#9662;</button>' +
      '</div>' +
      '<div class="vs-cov-list" hidden></div>' +
      '<div class="vs-picks">' +
      '<label>Data <select class="vs-data">' +
      dataLabels.map(function (d) {
        return '<option value="' + escapeHtml(d) + '"' + (d === best.o1 ? ' selected' : '') + '>' + escapeHtml(d) + '</option>';
      }).join('') + '</select></label>' +
      '<label>Days <select class="vs-days">' +
      dayLabels.map(function (d) {
        return '<option value="' + escapeHtml(d) + '"' + (d === best.o2 ? ' selected' : '') + '>' + escapeHtml(d) + '</option>';
      }).join('') + '</select></label>' +
      '</div>' +
      '<div class="vs-row"><span class="vs-price"></span>' +
      '<button class="vs-buy" type="button">Buy Now</button></div>';
    card.innerHTML = html;

    var selData = card.querySelector('.vs-data'),
        selDays = card.querySelector('.vs-days'),
        priceEl = card.querySelector('.vs-price'),
        buyBtn = card.querySelector('.vs-buy'),
        covBtn = card.querySelector('.vs-cov-btn'),
        covList = card.querySelector('.vs-cov-list');

    if (!coverage.length) {
      covBtn.style.display = 'none';
    } else {
      // highlight the countries the customer actually searched for
      var qSet = {};
      (q.countries || []).forEach(function (c) { qSet[String(c).toLowerCase()] = 1; });
      covList.innerHTML = coverage.map(function (c) {
        return qSet[c.toLowerCase()]
          ? '<span class="vs-cov-hit">' + escapeHtml(c) + '</span>'
          : escapeHtml(c);
      }).join(', ');
      covBtn.addEventListener('click', function () {
        var open = covList.hasAttribute('hidden');
        if (open) {
          covList.removeAttribute('hidden');
          covBtn.setAttribute('aria-expanded', 'true');
          covBtn.innerHTML = 'Countries (' + coverage.length + ') &#9652;';
        } else {
          covList.setAttribute('hidden', '');
          covBtn.setAttribute('aria-expanded', 'false');
          covBtn.innerHTML = 'Countries (' + coverage.length + ') &#9662;';
        }
      });
    }

    function refresh() {
      var v = findVariant(variants, selData.value, selDays.value) ||
              bestVariant(variants, dayNum(selDays.value), dataToMB(selData.value));
      if (v) {
        priceEl.textContent = money(v.price);
        buyBtn.dataset.variantId = v.id;
        buyBtn.disabled = false;
      } else { priceEl.textContent = ''; buyBtn.disabled = true; }
    }
    selData.addEventListener('change', refresh);
    selDays.addEventListener('change', refresh);
    buyBtn.addEventListener('click', function () {
      var vid = buyBtn.dataset.variantId;
      if (vid) buyNow(vid, buyBtn);
    });
    refresh();
  }

  function buyNow(variantId, btn) {
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    }).catch(function () {
      // fallback: plain form post
      var f = document.createElement('form');
      f.method = 'post'; f.action = '/cart/add';
      var i1 = document.createElement('input'); i1.name = 'id'; i1.value = variantId;
      var i2 = document.createElement('input'); i2.name = 'quantity'; i2.value = '1';
      var i3 = document.createElement('input'); i3.name = 'return_to'; i3.value = '/checkout';
      f.appendChild(i1); f.appendChild(i2); f.appendChild(i3);
      document.body.appendChild(f); f.submit();
    }).finally(function () { btn.disabled = false; btn.textContent = orig; });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- speech recognition ---------- */
  var rec = null, listening = false;

  function setMic(on) {
    listening = on;
    if (els.mic) {
      els.mic.classList.toggle('vs-listening', on);
      els.mic.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function toggleMic() {
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { status('Voice search is not supported in this browser — please type instead.'); return; }
    if (listening) { try { rec.stop(); } catch (e) {} return; }
    // instant tap feedback (flash), even if recognition can't start
    if (els.mic) {
      els.mic.classList.remove('vs-tap');
      void els.mic.offsetWidth;
      els.mic.classList.add('vs-tap');
      setTimeout(function () { if (els.mic) els.mic.classList.remove('vs-tap'); }, 500);
    }
    var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent || '');
    status('Starting microphone…');
    // iOS Safari: webkitSpeechRecognition.start() silently fails unless mic
    // permission is already granted — pre-flight with getUserMedia first.
    if (isIOS && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
        try { stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {}
        beginRec(SR, isIOS);
      }).catch(function () {
        status('Microphone is blocked — allow it in iPhone Settings > Safari, or tap the text box and use the keyboard mic 🎤.');
      });
    } else {
      beginRec(SR, isIOS);
    }
  }

  function beginRec(SR, isIOS) {
    try {
      rec = new SR();
    } catch (e) { status('Could not start voice search — please type instead.'); return; }
    rec.lang = REC_LANG;
    rec.interimResults = true;
    rec.maxAlternatives = 1;
    var gotResult = false, startTime = Date.now();
    rec.onresult = function (e) {
      var txt = '', fin = false;
      for (var i = e.resultIndex; i < e.results.length; i++) {
        txt += e.results[i][0].transcript;
        if (e.results[i].isFinal) fin = true;
      }
      gotResult = true;
      els.input.value = txt;
      status(fin ? 'Got it — searching…' : 'Listening… ' + txt);
      if (fin) doSearch(txt);
    };
    rec.onerror = function (e) {
      var err = (e && e.error) || '';
      if (err === 'not-allowed' || err === 'service-not-allowed') {
        status('Microphone is blocked — allow mic access in the browser settings, or type instead.');
      } else if (!gotResult) {
        status(isIOS
          ? 'Voice did not start on this iPhone — tap the text box and use the keyboard mic 🎤 instead.'
          : 'Voice input is not working in this browser — please type instead.');
      }
      setMic(false);
    };
    rec.onend = function () {
      setMic(false);
      if (!gotResult && Date.now() - startTime < 1500) {
        status(isIOS
          ? 'Voice did not start on this iPhone — tap the text box and use the keyboard mic 🎤 instead.'
          : 'Voice input did not start — please type instead.');
      }
    };
    try {
      rec.start();
      setMic(true);
      status('Listening… speak now');
    } catch (e) {
      status('Could not start voice search — please type instead.');
      setMic(false);
    }
  }

  /* ---------- init ---------- */
  function init() {
    var root = document.querySelector('.vs-wrap');
    if (!root) return;
    els = {
      root: root,
      mic: $('.vs-mic', root),
      input: $('.vs-text', root),
      go: $('.vs-go', root),
      status: $('.vs-status', root),
      results: $('.vs-results', root)
    };
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR && els.mic) els.mic.style.display = 'none';

    els.mic.addEventListener('click', toggleMic);
    els.go.addEventListener('click', function () { doSearch(els.input.value); });
    els.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); doSearch(els.input.value); }
    });
  }

  // expose parser for testing
  window.VS = { parseQuery: parseQuery, matchProducts: matchProducts, cn2num: cn2num, dataToMB: dataToMB };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
